import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { TruncatingTextWebElement } from './TruncatingTextWebElement';
export { TruncatingTextWebElement };

/**
 * Retrieve an instance of [TruncatingTextWebElement](../classes/TruncatingTextWebElement.html).
 * @example
 * ```javascript
 * import { findTruncatingText } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findTruncatingText(driver, By.id('my-oj-c-truncating-text'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findTruncatingText(
  driver: DriverLike,
  by: By
): Promise<TruncatingTextWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type TruncatingTextWebElement
  if (!(webEl instanceof TruncatingTextWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'TruncatingTextWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findTruncatingText(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${TruncatingTextWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-truncating-text', TruncatingTextWebElement);
